export const insertIntoArray = (what: any, where: any[], index: number) => [
  ...where.slice(0, index),
  what,
  ...where.slice(index, where.length),
];
